import { render } from "./OtpVerified.vue?vue&type=template&id=65cff8e1&scoped=true"
const script = {}

import "./OtpVerified.vue?vue&type=style&index=0&id=65cff8e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cff8e1"]])

export default __exports__